import { render, staticRenderFns } from "./BackToSearch.vue?vue&type=template&id=6fa912d0&"
import script from "./BackToSearch.vue?vue&type=script&lang=js&"
export * from "./BackToSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports